<mat-tree
  [dataSource]="dataSource"
  [treeControl]="treeControl"
  class="tree sidebar__menu"
  [ngClass]="!isFolderSelect ? 'small' : 'large'"
  data-cy="folder-menu"
>
  <mat-tree-node
    *matTreeNodeDef="let node"
    [matTreeNodePadding]="!isFolderSelect && node.level > 5 ? 5 : node.level"
    [matTreeNodePaddingIndent]="25"
    class="tree__node {{ node.level === 0 ? 'tree__node-root' : 'tree__node-child' }}"
    [ngClass]="nestedLevelClass(node.level)"
    [title]="foldersToDisable.includes(node.id) ? 'Folders cannot be moved within themselves.' : node.title"
  >
    <li class="flex-container align-middle sidebar__item" data-cy="folder-node">
      <a
        *ngIf="!isFolderSelect"
        [routerLink]="node.level === 0 ? '/folders' : '/folders/' + node.id"
        routerLinkActive="is-active"
        #rla="routerLinkActive"
        [routerLinkActiveOptions]="{ exact: true }"
        class="align-middle sidebar__link"
        [class.tree__node-link]="node.level !== 0"
        (mouseenter)="
          dragDrop.target = {
            region: DragDropRegion.FolderMenuNode,
            value: node
          }
        "
        (mouseleave)="dragDrop.target = undefined"
      >
        <div class="flex-container align-middle">
          <rav-icon [title]="node.title" [name]="rla.isActive ? 'folder' : 'folder-o'" class="sidebar__icon"></rav-icon>
          <span class="tree__node-text word-break">{{ node.title }} </span>
        </div>
      </a>

      <button
        *ngIf="isFolderSelect"
        (click)="selectNode(node)"
        class="sidebar__link borderless tree__node-button"
        [class.is-active]="node.isActive"
        [disabled]="foldersToDisable.includes(node.id)"
      >
        <div class="flex-container align-middle">
          <rav-icon [name]="node.isActive ? 'folder' : 'folder-o'" class="sidebar__icon"></rav-icon>
          <span class="tree__node-text word-break">{{ node.title }} </span>
        </div>
      </button>

      <i
        *ngIf="node.children?.length > 0 && !foldersToDisable.includes(node.id)"
        class="tree__arrow fa fa-lg {{ treeControl.isExpanded(node) ? 'fa-caret-up' : 'fa-caret-down' }}"
        matTreeNodeToggle
        [matTreeNodeToggleRecursive]="true"
      ></i>
      <ul *ngIf="node.children?.length > 0" [class.tree-invisible]="!treeControl.isExpanded(node)">
        <ng-container matTreeNodeOutlet></ng-container>
      </ul>
    </li>
  </mat-tree-node>
</mat-tree>
